import { renderSlot as _renderSlot, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "circles" }
const _hoisted_2 = { class: "empty-icon" }
const _hoisted_3 = { class: "text" }
const _hoisted_4 = { class: "sub-text" }
const _hoisted_5 = { class: "link pointer" }
const _hoisted_6 = { class: "actions" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Icon = _resolveComponent("Icon")

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["empty-wrapper", {bordered: $props.bordered, shadow: $props.shadow}])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        (_ctx.$slots.image)
          ? _renderSlot(_ctx.$slots, "image", { key: 0 }, undefined, true)
          : (_openBlock(), _createBlock(_component_Icon, {
              key: 1,
              draggable: false,
              class: "img",
              icon: $props.icon,
              alt: "file-type-icon"
            }, null, 8 /* PROPS */, ["icon"]))
      ])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _renderSlot(_ctx.$slots, "title", {}, undefined, true)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _renderSlot(_ctx.$slots, "sub-text", {}, undefined, true)
    ]),
    _createElementVNode("div", _hoisted_5, [
      _renderSlot(_ctx.$slots, "link", {}, undefined, true)
    ]),
    _createElementVNode("div", _hoisted_6, [
      _renderSlot(_ctx.$slots, "actions", {}, undefined, true)
    ])
  ], 2 /* CLASS */))
}